import React from "react";
import './styles.scss';

const Question = ({ heading, headingType, description, list, list2, descriptionList }) => (
  <div className='question'>
    <h3 className={headingType}>{heading}</h3>

    {list && (
      <>
        <p style={{ fontSize: '18px' }}>For example, any of the following:</p>
        <ul className='mainList'>
          {list.map((item, idx) => {
            return <li key={idx}>{item}</li>
          })}
        </ul>
      </>

    )}
    {list2 && (
      <>
        <p style={{ fontSize: '18px' }}>OR</p>
        <ul className='mainList'>
          {list2.map((item, idx) => {
            return <li key={idx}>{item}</li>
          })}
        </ul>
      </>
    )}

    <p dangerouslySetInnerHTML={{ __html: description }} />
    {descriptionList && (
      <ul className='descriptionList'>
        {descriptionList.map((item, idx) => {
          return <li key={idx}>{item}</li>
        })}
      </ul>
    )}
  </div>
);

export default Question;